import { post, get, put } from '@api/request';

export const quickCaseLookup = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  let url = `${litigationService}/litigation/case/search?page=1&pageSize=50`;

  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const createCase = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/cases`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchCase = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateCase = async (
  { litigationService },
  authenticationToken,
  { payload, caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateCaseTaxYears = async (
  { litigationService },
  authenticationToken,
  { payload, caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/taxyears`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchCaseSummary = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/summary`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const reopenCase = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/reopen`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchRollCorrs = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/taxyearproposedrollcorrections`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const finalizeCase = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/finalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const simpleFinalizeCase = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/simplefinalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const importAppealAppraisers = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/importappealappraisers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};
